// client/src/apiConfigImgs.js
const IMG_HOST = process.env.REACT_APP_IMG_HOST_PROD;
export default IMG_HOST;